import React, { FC } from 'react';
import { InfoInCircle } from '@td-client-frontend/icons';
import { LabelWithIconTooltip } from '@td-client-frontend/common';
import { registrationTierTooltipValues, registrationMCPTooltipValues } from './constants';

interface Props {
  type: string;
}

const Content: FC<{ tooltipValues: string[] }> = ({ tooltipValues }) => (
  <div className="flex flex-col space-y-4">
    {tooltipValues.map((item: string, index) => (
      <span key={`${item}-${index}`} className="font-effra text-sm text-white">
        {item}
      </span>
    ))}
  </div>
);

export const TierRulesTooltip: FC<Props> = ({ type }) => (
  <LabelWithIconTooltip
    dataFor={`${type}-marketingChannelPermission`}
    tooltipLabel="Marketing channel permission"
    tooltipBody={<Content tooltipValues={registrationMCPTooltipValues} />}
    tooltipIcon={<InfoInCircle className="ml-2 w-4 h-4" />}
    tooltipSetting={{
      className: 'w-96 !opacity-100',
      border: false
    }}
    wrapperClasses="flex items-center mb-2"
    labelClasses="font-effra text-gray-60 text-lg"
  />
);

export const TierTooltip: FC<Props> = ({ type }) => (
  <LabelWithIconTooltip
    dataFor={`${type}Tier`}
    tooltipLabel="Tier"
    tooltipBody={<Content tooltipValues={registrationTierTooltipValues} />}
    tooltipIcon={<InfoInCircle className="ml-2" />}
    tooltipSetting={{
      className: 'w-96 !opacity-100',
      border: false
    }}
    wrapperClasses="flex items-center mb-2"
    labelClasses="font-effra text-gray-60 text-lg"
  />
);
